import React from 'react';
import { AdvancedDatePickerWrapper } from 'react-lib/dist/components-es';
import CurrentRemoveDateButtonsWrapper from './CurrentRemoveDateButtonsWrapper';
import GridColumnInputWrapper from './GridColumnInputWrapper';

type Props = {
  dteValue?: any;
  dteName?: string;
  dteLabel?: string;
  openDirection?: string;
  renderDefaultButtons?: boolean;
  updateUserDateFieldsValidation: () => void;
  userValue: any;
  setFieldValue: (name: string, value: any) => void;
};

const UserDateAdvancedDatePicker: React.FC<Props> = ({
  dteValue,
  dteName,
  dteLabel,
  openDirection,
  renderDefaultButtons,
  updateUserDateFieldsValidation,
  userValue,
  ...props
}) => {
  return (
    <GridColumnInputWrapper
      {...props}
      value={dteValue}
      name={dteName}
      label={dteLabel}
      specialRequiredCondition={userValue != null}
      onChange={updateUserDateFieldsValidation}
      className={renderDefaultButtons ? 'inputWithTwoInputDefaultButtons' : 'inputWidthStretched'}
      render={(props: any) => (
        <AdvancedDatePickerWrapper
          {...props}
          noBorder
          openDirection={openDirection}
          renderDefaultButtons={
            renderDefaultButtons ? (
              <CurrentRemoveDateButtonsWrapper {...props} dteName={dteName} />
            ) : null
          }
        />
      )}
    />
  );
};

export default UserDateAdvancedDatePicker;
